import { fromJS } from 'immutable';
import { createSelector } from 'reselect';

import { GetGeneratedPaymentLink, GetPendingPayment } from '../../api/PendingPayment';

// ACTIONS TYPES
export const FETCH_PENDING_PAYMENT_SUCCESS = 'customer-portal/payments/FETCH_PENDING_PAYMENT_SUCCESS';
export const FETCH_PENDING_PAYMENT_FAILURE = 'customer-portal/payments/FETCH_PENDING_PAYMENT_FAILURE';
export const FETCHING_PENDING_PAYMENT = 'customer-portal/payments/FETCHING_PENDING_PAYMENT';

export const FETCH_GENERATED_PAYMENT_LINK_SUCCESS = 'customer-portal/payments/FETCH_GENERATED_PAYMENT_LINK_SUCCESS';
export const FETCH_GENERATED_PAYMENT_LINK_FAILURE = 'customer-portal/payments/FETCH_GENERATED_PAYMENT_LINK_FAILURE';
export const FETCHING_GENERATED_PAYMENT_LINK = 'customer-portal/payments/FETCHING_GENERATED_PAYMENT_LINK';

// ACTION CREATORS
export const fetchPendingPaymentSuccess = pendingPayment => ({
  type: FETCH_PENDING_PAYMENT_SUCCESS,
  payload: pendingPayment,
});

export const fetchPendingPaymentFailure = err => ({
  type: FETCH_PENDING_PAYMENT_FAILURE,
  payload: err,
});

export const fetchingPendingPayment = () => ({
  type: FETCHING_PENDING_PAYMENT,
});

export const fetchGeneratedPaymentLinkSuccess = pendingPayment => ({
  type: FETCH_GENERATED_PAYMENT_LINK_SUCCESS,
  payload: pendingPayment,
});

export const fetchGeneratedPaymentLinkFailure = err => ({
  type: FETCH_GENERATED_PAYMENT_LINK_FAILURE,
  payload: err,
});

export const fetchingGeneratedPaymentLink = () => ({
  type: FETCHING_GENERATED_PAYMENT_LINK,
});

// THUNKS
export const fetchPendingPayment = prospectId => async dispatch => {
  dispatch(fetchingPendingPayment());
  try {
    const pendingPayment = await GetPendingPayment(prospectId);
    dispatch(fetchPendingPaymentSuccess(pendingPayment));
  } catch (error) {
    dispatch(fetchPendingPaymentFailure(error));
  }
};

export const shouldFetchPendingPayment = pendingPaymentState => !pendingPaymentState.get('loading');

export const fetchPendingPaymentIfNeeded = prospectId => (dispatch, getState) => {
  if (!shouldFetchPendingPayment(getState().payments.get('pendingPayment'))) {
    return null;
  }

  return dispatch(fetchPendingPayment(prospectId));
};

export const fetchGeneratedPaymentLink = prospectId => async dispatch => {
  dispatch(fetchingGeneratedPaymentLink());
  try {
    const generatedPaymentLink = await GetGeneratedPaymentLink(prospectId);
    dispatch(fetchGeneratedPaymentLinkSuccess(generatedPaymentLink));
  } catch (error) {
    dispatch(fetchGeneratedPaymentLinkFailure(error));
  }
};

export const shouldFetchGenearatedPaymentLink = generatedPaymentLinkState => !generatedPaymentLinkState.get('loading');

export const fetchGeneratedPaymentLinkIfNeeded = prospectId => (dispatch, getState) => {
  if (!shouldFetchGenearatedPaymentLink(getState().payments.get('generatedPaymentLink'))) {
    return null;
  }

  return dispatch(fetchGeneratedPaymentLink(prospectId));
};

// // SELECTORS

const paymentSelector = state => state.payments;

export const getPendingPayment = createSelector([paymentSelector], payments => payments.get('pendingPayment').get('data'));

export const getPendingPaymentLoading = createSelector([paymentSelector], payments => payments.get('pendingPayment').get('loading'));

export const getPendingPaymentError = createSelector([paymentSelector], payments => payments.get('pendingPayment').get('error'));

export const getGeneratedPaymentLink = createSelector([paymentSelector], payments => payments.get('generatedPaymentLink').get('data'));

export const getGeneratedPaymentLinkLoading = createSelector([paymentSelector], payments => payments.get('generatedPaymentLink').get('loading'));

export const getGeneratedPaymentLinkError = createSelector([paymentSelector], payments => payments.get('generatedPaymentLink').get('error'));

// // REDUCER
export const initialState = fromJS({
  pendingPayment: {
    data: {},
    loading: false,
    error: null,
  },
  generatedPaymentLink: {
    data: {},
    loading: false,
    error: null,
  },
});

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_PENDING_PAYMENT:
      return state.setIn(['pendingPayment', 'loading'], true).setIn(['pendingPayment', 'error'], null);
    case FETCH_PENDING_PAYMENT_SUCCESS:
      return state.setIn(['pendingPayment', 'data'], action.payload).setIn(['pendingPayment', 'loading'], false);
    case FETCH_PENDING_PAYMENT_FAILURE:
      return state.setIn(['pendingPayment', 'loading'], false).setIn(['pendingPayment', 'error'], action.payload);
    case FETCHING_GENERATED_PAYMENT_LINK:
      return state.setIn(['generatedPaymentLink', 'loading'], true).setIn(['generatedPaymentLink', 'error'], null);
    case FETCH_GENERATED_PAYMENT_LINK_SUCCESS:
      return state.setIn(['generatedPaymentLink', 'data'], action.payload).setIn(['generatedPaymentLink', 'loading'], false);
    case FETCH_GENERATED_PAYMENT_LINK_FAILURE:
      return state.setIn(['generatedPaymentLink', 'loading'], false).setIn(['generatedPaymentLink', 'error'], action.payload);
    default:
      return state;
  }
};
